export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
    >
      {/* Background Image */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/bedaedbd17abc5d004a1c5630ca499e5.jpg"
          alt="Hong Kong AI Ecosystem"
          className="w-full h-full object-cover object-top"
        />
      </div>

      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/45 to-black/65" />

      {/* Content */}
      <div className="relative z-10 w-full max-w-4xl mx-auto px-6 text-center">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 bg-amber-600/20 border border-amber-500/40 text-amber-300 text-xs font-semibold px-4 py-1.5 rounded-full mb-8 backdrop-blur-sm">
          <span className="w-1.5 h-1.5 rounded-full bg-amber-400 animate-pulse inline-block" />
          Hong Kong AI Ecosystem Scout · 2026
        </div>

        {/* Main Title */}
        <h1 className="text-5xl md:text-7xl font-bold text-white leading-tight tracking-tight mb-6" style={{ fontFamily: "'Noto Serif TC', serif" }}>
          香港AI生態
          <br />
          <span className="text-amber-400">連接者</span>
        </h1>

        {/* Subtitle */}
        <p className="text-lg md:text-xl text-white/80 max-w-2xl mx-auto leading-relaxed mb-10">
          我在 Cyberport 與 HKSTP 每天接觸早期 AI 項目，<br className="hidden md:block" />
          專門幫助優質 AI 初創連接 Family Offices 與耐心資本。
        </p>

        {/* Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
          <a
            href="#submit"
            className="bg-amber-600 hover:bg-amber-500 text-white font-bold px-8 py-4 rounded-md text-base transition-all hover:scale-105 whitespace-nowrap cursor-pointer w-full sm:w-auto"
          >
            提交你的 AI 項目
          </a>
          <a
            href="#who-i-am"
            className="bg-white/10 hover:bg-white/20 border border-white/30 text-white font-semibold px-8 py-4 rounded-md text-base transition-all backdrop-blur-sm whitespace-nowrap cursor-pointer w-full sm:w-auto"
          >
            了解更多
          </a>
        </div>

        {/* Stats strip */}
        <div className="inline-flex items-center gap-2 bg-black/30 border border-white/10 backdrop-blur-sm rounded-full px-5 py-2.5">
          <i className="ri-sparkling-line text-amber-400 text-sm" />
          <p className="text-white/60 text-xs md:text-sm">
            2026 年最新 — Cyberport 擁有超過 <strong className="text-white/90">500 家 AI 初創</strong> + <strong className="text-white/90">3000 PFLOPS</strong> AISC 超算中心
          </p>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
        <span className="text-white/40 text-xs">Scroll</span>
        <i className="ri-arrow-down-line text-white/40 text-lg" />
      </div>
    </section>
  );
}
